export const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export const DAY_DATE_FORMAT = 'ddd D MMM yyyy,';

export const DAY_DATE_MONTH_FORMAT = 'ddd D MMM';

export const DAY_COMMA_DATE_FORMAT = 'ddd, D MMM yyyy';

export const DATE_MONTH_FORMAT = 'D MMM';

export const MONTH_DATE_FORMAT = 'MMM D';

export const DATE_FORMAT = 'D MMM yyyy';

export const DAY_FORMAT = 'ddd';

export const DAY_FULL_FORMAT = 'dddd';

export const FULL_MONTH_YEAR_FORMAT = 'MMMM yyyy';

export const MONTH_YEAR_FORMAT = 'MM-yyyy';

export const API_DATE_FORMAT = 'YYYY-MM-DD';

export const TIME_24_FORMAT = 'H:mm';

export const TIME_AM_PM_FORMAT = 'h:mma';

export const TIME_DURATION_FORMAT = 'H[h] mm[m]';

export const HOURS_DURATION_FORMAT = 'H[h]';

export const MINUTES_DURATION_FORMAT = 'mm[m]';

export const MAX_DATE_TIME = '9988-12-30T23:59:00';

export const ISO_TIME_FORMAT = 'HH:mm:ss';

export const MESSAGE_CENTER_DATE_FORMAT = 'DD/MM/YYYY';
